module.exports = __webpack_public_path__ + "static/banner-fb04c614307b453741e18c2632cc2f93.jpg";